var app = angular.module('app', [
    'ui.bootstrap',
    'ui.router',
    'ngCookies',
    'ngAnimate',
    'ngSanitize',
    'ng-fastclick',
    'angular-swipe-element',
    'satellizer'
]);

app.config(['$compileProvider', function ($compileProvider) {
  $compileProvider.debugInfoEnabled(false);
}]);

app.run( function run($rootScope,$state,$auth,errorService,objectService,questionService){
    $rootScope.$state = $state;
    $rootScope.toggles = {
        showMenu: false
    },

    // Reset errors on view change
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        errorService.reset();
    });

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

        if(toState.name != 'signin' && toState.name != 'preview'){
            // Prevent all states if not authorized.
            if(!$auth.isAuthenticated()){
                event.preventDefault();
                $state.go('signin');
                return false;
            }

            if(toState.name != 'start' && !objectService.objectFetched) {
                event.preventDefault();
                if(objectService.getReviewMode()){
                    $state.go('preview');
                } else {
                    $state.go('start');
                }
                return false;
            }
        }
    })
});

app.config(function($httpProvider) {

    // $locationProvider.html5Mode(true);

    // Catch all xhr errors and push them to errorService
    $httpProvider.interceptors.push(function($q, errorService) {
        return {
            'response': function(response){
                typeof response.data !== 'string' && debug('XHR Response:',response);
                return response;
            },
            'requestError': function(rejection) {
                debug('XHR Request rejection:',rejection);
                rejection.data && errorService.error('Fel vid anrop.', rejection.data.message);
                return $q.reject(rejection);
            },
            'responseError': function(rejection) {
                debug('XHR Response rejection:',rejection);
                rejection.data && errorService.error('Fel vid anrop.', rejection.data.message);
                return $q.reject(rejection);
            }
        };
    });
});
